import React, { useState } from 'react'
import styled from 'styled-components'
import OpenIcon from './icons/open'
import ArchiveIcon from '../../icons/archive'
import ThreeDotsButton from '../../three-dots-button'
import Menu, { MenuAnchorWrapperElement, MenuItem } from '../../menu'
import { useMutation } from '@apollo/react-hooks'
import ArchiveDocFile from '../../../queries/ArchiveDocFile'
import UnarchiveDocFile from '../../../queries/UnarchiveDocFile'
import MoveIcon from './icons/move'
import MoveFileModal from './move-file-modal'
import RenameIcon from './icons/rename'
import { useDocumentsConfig } from '../../../contexts/DocumentsConfigContext'
import RenameFileModal from './rename-file-modal'

const OptionWrapperElement = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const OptionElement = styled.p`
  font-size: 0.8rem;
  color: #56565a;
  margin: 0;
  text-wrap: nowrap;
`

function FileOptions({ file, documentId }) {
  const { uuid: fileUuid, fileUrl, archived } = file

  const [openMenu, setOpenMenu] = useState(false)
  const [showMoveFileModal, setShowMoveFileModal] = useState(false)
  const [showRenameFileModal, setShowRenameFileModal] = useState(false)
  const { fileRenamingEnabled } = useDocumentsConfig()

  const mutationConfig = {
    variables: {
      input: {
        documentId,
        fileUuid,
      },
    },
  }

  const [archiveFileMutation] = useMutation(ArchiveDocFile, mutationConfig)
  const [unarchiveFileMutation] = useMutation(UnarchiveDocFile, mutationConfig)

  return (
    <>
      <MenuAnchorWrapperElement>
        <ThreeDotsButton onClick={() => setOpenMenu(true)} />
        {openMenu && (
          <Menu title="Document actions" onClose={() => setOpenMenu(false)}>
            <MenuItem onClick={() => window.open(fileUrl, '_blank')}>
              <OptionWrapperElement>
                <OpenIcon />
                <OptionElement>Open document</OptionElement>
              </OptionWrapperElement>
            </MenuItem>
            {fileRenamingEnabled && (
              <MenuItem onClick={() => setShowRenameFileModal(true)}>
                <OptionWrapperElement>
                  <RenameIcon />
                  <OptionElement>Rename document</OptionElement>
                </OptionWrapperElement>
              </MenuItem>
            )}
            <MenuItem onClick={() => setShowMoveFileModal(true)}>
              <OptionWrapperElement>
                <MoveIcon />
                <OptionElement>Move document</OptionElement>
              </OptionWrapperElement>
            </MenuItem>
            <MenuItem
              onClick={archived ? unarchiveFileMutation : archiveFileMutation}
            >
              <OptionWrapperElement>
                <ArchiveIcon />
                <OptionElement>
                  {archived ? 'Unarchive' : 'Archive'} document
                </OptionElement>
              </OptionWrapperElement>
            </MenuItem>
          </Menu>
        )}
      </MenuAnchorWrapperElement>
      {showMoveFileModal && (
        <MoveFileModal
          onClose={() => setShowMoveFileModal(false)}
          documentId={documentId}
          file={file}
        />
      )}
      {showRenameFileModal && (
        <RenameFileModal
          onClose={() => setShowRenameFileModal(false)}
          documentId={documentId}
          file={file}
        />
      )}
    </>
  )
}

export default FileOptions
